import { parseApiDate, APIDateFormats, parseApiDuration } from '../../utils/Date.js';
import { ParcelTrackingMapper } from './ParcelTracking/ParcelTrackingMapper.js';
import { TrackingStatusInfoMapper } from './TrackingStatus/TrackingStatusInfoMapper.js';

class TrackingMapper {
  static createModelFromResponse(data) {
    if (!data) {
      return undefined;
    }
    return {
      shipmentReference: data.shipment_reference,
      currentStatus: data.current_status,
      currentStatusInfo: TrackingStatusInfoMapper.createModelFromResponse(data.current_status_info),
      lastSynchronizationSucceeded: parseApiDate(data.last_synchronization_succeeded, APIDateFormats.complete),
      estimatedTimeOfDelivery: parseApiDate(data.estimated_time_of_delivery, APIDateFormats.date),
      transitStartTime: parseApiDate(data.transit_start_time, APIDateFormats.complete),
      transitEndTime: parseApiDate(data.transit_end_time, APIDateFormats.complete),
      transitDuration: parseApiDuration(data.transit_duration),
      parcels: data.parcels.map(ParcelTrackingMapper.createModelFromResponse)
    };
  }
}

export { TrackingMapper };
//# sourceMappingURL=TrackingMapper.js.map
